import { PathwayDto } from '@app/admin/store/pathway/models';

import { USER_ROLE } from '../types/user-role.type';
import { UserDto } from './user.dto';
import { UserStats } from './userStats';

export class User {
    id: number;
    schoolId: number;
    email: string;
    firstName: string;
    lastName: string;
    description: string;
    role: USER_ROLE;
    pathId: number | null;
    stats: UserStats;
    location: string;
    joinedAt?: Date;
    avatarSrc: string;

    constructor(data: UserDto) {
        this.id = data.id;
        this.schoolId = data.schoolId;
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.role = data.role;
        this.pathId = data?.pathId ?? null;
        this.stats = new UserStats();
        this.description = data.description ?? '';
        this.location = data.location ?? '';
        this.joinedAt = data.joinedAt ? new Date(data.joinedAt) : undefined;
        this.avatarSrc = data.avatarSrc ?? `https://avatar.iran.liara.run/username?username=${this.firstName}+${this.lastName}`;
    }

    adaptTotalCourses(pathwaysDto: PathwayDto[]) {
        const pathway = pathwaysDto.find((path) => path.id === this.pathId);
        this.stats.totalCourses = pathway?.courseIds.length ?? 0;
    }
}
